Drupal.behaviors.sw_collapsers = {
	attach: function( context, settings ) {
		$('.collapser, .js-collapser').once('sw_collapser').each(function() {
			var c = new Collapser($(this));
		});
	}
};

jQuery.fn.collapser = function () {
	return $(this).data('collapser');
};

var Collapser = function($wrap) {
	var _this = this;

	this.$c = $wrap;
	this.$cc = this.$c.find('.collapser__content, .js-collapser__content');
	this.$t = this.$c.find('.collapser__title, .js-collapser__title');

	this.group = this.$c.data('collapser-group');

	this.$c.data('collapser', this);

  if ( this.$c.hasClass('js-collapser--hover')) {
    this.$c.on('mouseenter', function() {
      _this.open();
    });
    this.$c.on('mouseleave', function() {
      _this.close();
    });
  } else {
    this.$t.on('click',function(e) {
      e.preventDefault();
      if ( _this.$c.hasClass('collapser--open')) {
        _this.close();
      } else {
        _this.open();
      }
    });
  }

	setTimeout(function() {
		if ( _this.$c.hasClass('collapser--open')) {
			_this.open(1);
		} else {
			_this.close(1);
		}
	},1);
};
Collapser.prototype.open = function(no_anim) {
	var all = this.group_find();
	for ( var i in all ) {
		var c = all[i];
		if ( c !== this ) {
			c.close(no_anim);
		}
	}
	var $img = this.bound_image_find();
	if ( no_anim) {
		this.$cc.show();
		if ( $img ) {
			$img.show();
		}
	} else {
		this.$cc.stop().slideDown(400, function() {
      $(this).css('height','auto');
    });
		if ( $img ) {
			$img.stop().fadeIn(300);
		}
	}
  this.$c.addClass('collapser--open');
};
Collapser.prototype.close = function(no_anim) {
	var $img = this.bound_image_find();
	if ( no_anim) {
		this.$cc.hide();
		if ( $img ) {
			$img.hide();
		}
	} else {
		this.$cc.stop().slideUp(400, function() {
      $(this).css('height','auto');
    });
		if ( $img ) {
			$img.stop().fadeOut(300);
		}
	}
  this.$c.removeClass('collapser--open');
};
Collapser.prototype.group_find = function() {
	var collapsers = [];
	$('.collapser,.js-collapser').filter('[data-collapser-group="'+this.group+'"]').each(function() {
		collapsers.push($(this).collapser());
	});
	return collapsers;
};
Collapser.prototype.bound_image_find = function() {
	if ( this.group ) {
		var all = this.group_find();
		var index = -1;
		for ( var i in all ) {
			if ( all[i] === this ) {
				index = parseInt(i);
				break;
			}
		}
		if ( index !== -1 ) {
			var $img = $('.js-collapser-image[data-collapser-group="'+this.group+'"][data-collapser-image-id="'+(index+1)+'"]');
			return $img.length ? $img : null;
		}
	}
	return null;
};
